import {  AlertController } from '@ionic/angular';
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

@Injectable()
export class LoginAlert {
    isLoading = false;
    constructor( public alertController: AlertController,private router:Router) {

    }
  
      async presentAlertConfirm() {
        const alert = await this.alertController.create({
          cssClass: 'my-custom-class',
          header: 'Login!',
          message: 'You not logged In!!! <strong>Do you want to login??</strong>',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: (blah) => {
              }
            }, {
              text: 'Login',
              handler: () => {
                this.router.navigate(["login"], { replaceUrl: true });
              }
            }
          ]
        });
    
        await alert.present();
      }

      
      public showAlert() {
        this.presentAlertConfirm()
      }
      public dismissAlert() {
        this.alertController.dismiss();
    }
   
}